export default undefined; // eslint-disable-line no-undefined



// WEBPACK FOOTER //
// ./app/helpers/empty.js